import wxBridge from '../jsbridge/jsbridge_base.js';
import env from '../common/env.js';

wxBridge.openGameLifeChatroom = wxBridge.openGameLifeChatroom || function (param, callback) {
    if( env.isAndroid ) {
        wxBridge.invoke('openGameLifeChatroom', param, callback);
    } else { // iOS后续jsapi通过gameCenterFacade进行分发
        let identifier = "openGameLifeChatroom-" + Date.now();
        wxBridge.invoke('gameCenterFacade', {
            "gamecenter_methodname": "openGameLifeChatroom",
            "gamecenter_identifier": identifier,
            "gamecenter_params": param
        }, (res) => {
            if (!res || res.gamecenter_identifier !== identifier) {
                return;
            }
            callback(res)
        })
    }
};

export default wxBridge;

export const {
    openGameLifeChatroom
} = wxBridge;
